module.exports = __webpack_public_path__ + "img/Wosslogo3.4242018f.png";